<template>
  <img
    :src="QumulexLogo"
    alt="Qumulex Logo"
    height="20"
  />
</template>

<script setup lang="ts">
import QumulexLogo from "@/assets/images/qumulex_logo_white.svg";
</script>
